import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCookieValue, isTokenValid } from '../../utils/tokenUtils';

interface Props {
  children: React.ReactNode;
  admin?: boolean;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  const token = getCookieValue('token');
  if (isTokenValid(token)) {
    return <Navigate to='/dashboard' />;
  }
  return <>{children}</>;
};

const ProtectedRoute: React.FC<Props> = ({ children, admin = true }) => {
  const token = getCookieValue('token');
  if (!isTokenValid(token)) {
    return <Navigate to='/' />;
  }
  if (!admin) {
    return <Navigate to='/dashboard' />;
  }
  return <>{children}</>;
};

export { ProtectedRoute, PublicRoute };
